export const customV57 = [
  {
    name: 'customV2_startPageV40',
    hideHeader: true,
    progressTitle: 'customV2_progress_text1',
  },
  {
    name: 'customV2_policyPageV5',
    hideHeader: true,
  },
  {
    name: 'customV2_gender',
  },
  {
    name: 'customV2_breed',
  },
  {
    name: 'customV2_age',
  },
  {
    name: 'info_about_nutrition',
    hideHeader: true,
    separationStep: true,
    progressTitle: 'customV2_progress_text16',
  },
  {
    name: 'customV2_food_type',
  },
  {
    name: 'customV2_food_allergies',
  },
  {
    name: 'customV2_health_goals',
  },
  {
    name: 'info_about_food_scanner',
    hideHeader: true,
  },
  {
    name: 'customV2_food_choice',
  },
  {
    name: 'age_group',
  },
  {
    name: 'statement_enjoy_time',
    separationStep: true,
  },
  {
    name: 'customV2_creating_program',
    hideProgress: true,
  },
  {
    name: 'customV2_plan',
    hideProgress: true,
  },
  {
    name: 'customV2_email',
    hideProgress: true,
  },
  {
    name: 'receive_email',
    hideProgress: true,
  },
  {
    name: 'customV2_specialOffer_v2',
    hideProgress: true,
  },
];
